var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDay = function SvgDay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.111328,
    width: 36,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_431_488)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 3.61133V5.11133M13.3198 6.84692L12.3298 5.78625M22.68 6.84692L23.6699 5.78625M17.9999 20.6113V19.1113M22.68 17.3757L23.67 18.4364M13.3198 17.3757L12.3299 18.4364M12 12.1113H10M24 12.1113H26M21.9999 12.1113C21.9999 14.3205 20.209 16.1113 17.9999 16.1113C15.7908 16.1113 13.9999 14.3205 13.9999 12.1113C13.9999 9.90219 15.7908 8.11133 17.9999 8.11133C20.209 8.11133 21.9999 9.90219 21.9999 12.1113Z",
    stroke: "white",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_488",
    x1: 1.5,
    y1: 5.61133,
    x2: 31,
    y2: 21.6113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA00"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDay);
export default ForwardRef;